import Model from '@/models/Model'
import _ from 'lodash'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'metas',
            name: 'meta',
            class: 'Modules\\Meta\\Entities\\Meta',
            lengthFields: {}

        }
    },

    computed: {
        titleMin() {
            return this.lengthFields.TITLE_MIN
        },

        titleMax() {
            return this.lengthFields.TITLE_MAX
        },

        descriptionMin() {
            return this.lengthFields.DESCRIPTION_MIN
        },

        descriptionMax() {
            return this.lengthFields.DESCRIPTION_MAX
        }
    },

    methods: {
        getNew() {
            return {
                title: null,
                description: null,
                keywords: null
            }
        },

        loadLengthFields() {
            return axios({
                method: 'get',
                url: route('api.metas.lengthFields')
            })
            .then(response => {
                if(response.data.success) {
                    this.lengthFields = response.data.data

                    return this.lengthFields
                }

                return Promise.reject(response.data.message)
            })
            .catch(error => Promise.reject(Object.values(error.response.data.errors)[0][0]))
        },

        loadMetableMeta(table, id) {
            return axios({
                method: 'get',
                url: route('api.metables.meta', {
                    metables: table,
                    metable: id
                })
            })
            .then(response => {
                if(response.data.success) {
                    return response.data.data
                }

                return Promise.reject(response.data.message)
            })
            .catch(error => Promise.reject(Object.values(error.response.data.errors)[0][0]))
        }
    }
}